export const Dictionary = {
  CANCELLED: 'Cancelled',
  INACCURATE: 'Inaccurate',
  MISSED: 'Missed'
}
